<template>
    <div id="DefaultMessageBox" class="message-box-container">

      <div
        v-show="showContent"
        id="MessageBoxContent"
        v-click-outside="onClickOutside"
        class="message-box-content"
      >
        <div id="MessageBoxHeader" class="message-box-header">
          <h4 class="message-box-header-title">
            {{ $t("sectionDefaultMessageBox.defaultMessage") }}
          </h4>
        </div>
        <div class="message-box-content-wrapper">
          <div class="d-flex flex-row">
            <div class="content-sub-item content-sub-item--description-header">
              {{ $t("sectionDefaultMessageBox.labelDescription") }}
            </div>
            <div class="content-sub-item content-sub-item--text-header">
              {{ $t("sectionDefaultMessageBox.labelMessage") }}
            </div>
          </div>
  
          <div class="content-sub-container">
            <div
      v-for="(message, index) in dataItemsTemp"
      :key="index"
      class="d-flex flex-row"
      :class="index === selectedMessageIndex ? 'content-sub-item--selected' : (index % 2 === 0 ? 'content-sub-item--stripped' : '')"
      @click="onClickMessage(message, index)"
      ref="messageItems"
    >
      <div class="content-sub-item content-sub-item--description">
        {{ message.descricao }}
      </div>
      <div class="content-sub-item content-sub-item--text">
        {{ message.texto }}
      </div>
    </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import VueI18n from "@/libs/i18n"
  
  export default {
    name: "DefaultMessageBoxComand",
    props: {
      talkSelected: {
        type: Object,
        default: Object
      },
      showContent: {
        type: Boolean,
        default: false
      },
      pesquisar: {
        type: String,
        default: ""
      },
      selectedMessageIndex: {
        type: Number,
        default: 0
      },
    },
    watch: {
        showContent(newValue) {
        if (newValue) {
            this.onMainButtonClick();
        }
        },
        pesquisar(pesquisarConteudo) {
            this.inputText = pesquisarConteudo;
            this.selectedMessageIndex = 0;
            this.searchTimeOut();
        },
        selectedMessageIndex(newValue) {
            if (newValue >= 0 && newValue < this.$refs.messageItems.length) {
            // Foca o elemento
            const elementToFocus = this.$refs.messageItems[newValue];
            elementToFocus.focus();

            // Rola o elemento para a visão, se necessário
            elementToFocus.scrollIntoView({
            behavior: 'smooth', // Isso fará com que a rolagem seja suave (opcional)
            block: 'start' // Isso fará com que o elemento seja rolado para o topo da visão
            });
        }
        }
    },
    mounted() {
        // Foca o primeiro elemento quando o componente é montado
        if (this.$refs.messageItems && this.$refs.messageItems.length > 0)
            this.$refs.messageItems[this.selectedMessageIndex].focus();
    },
  created() {
    // Event listener para a tecla Enter
    window.addEventListener("keydown", (event) => {
      if (event.key === "Enter" && this.showContent === true ) {
        this.handleEnterKey();
      }
    });
  },
    data() {
      return {
        openMessageBox: this.showContent,
        loadingMessages: false,
        timer: 0,
        inputText: "",
        dataItemsTemp: [],
        defaultMessages: [],
      }
    },
    computed: {
      controller() {
        const typeHereToSearch = VueI18n.t(
          "sectionDefaultMessageBox.typeHereToSearch"
        )
        return {
          open: this.openMessageBox,
          inputSearchPlaceHolder: typeHereToSearch,
          searchTime: 100
        }
      }
    },
    methods: {
    handleEnterKey() {
      // Lógica para lidar com a tecla Enter aqui
      const selectedMessage = this.dataItemsTemp[this.selectedMessageIndex];
      this.onClickMessage(selectedMessage, this.selectedMessageIndex);
    },
      onMainButtonClick() {
        this.defaultMessages = []
        this.dataItemsTemp = []
        //this.openMessageBox = !this.openMessageBox
        this.inputText = ""
        this.getDefaultMessages()
      },
      onClickOutside() {
        this.openMessageBox = false
        //this.showContent = false
        this.$emit('update:showContent', !this.showContent);
      },
      onClickMessage(e) {
        this.$emit("onClickMessage", e)
        this.openMessageBox = false
        //this.showContent = false
        this.$emit('update:showContent', !this.showContent);
      },
      getDefaultMessages() {
        //futuramente otimizar
        let vm = {
          ContaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
          ContatoId: this.talkSelected.contatoId,
          TipoContato: this.talkSelected.enumTipoContato
        }
  
        this.loadingMessages = true
        this.$http({
          url: "mensagem-padrao/obter-todos/",
          data: vm,
          method: "POST"
        })
          .then((response) => {
            this.loadingMessages = false
            this.defaultMessages = [...response.data]
            this.dataItemsTemp = [...response.data]
          })
          .catch((error) => {
            this.loadingMessages = false
  
            const errorGettingDefaultMessages = this.$t(
              "infoMessages.errorGettingDefaultMessages"
            )
  
            this.$notify({
              data: error.response.data.erros
                ? error.response.data.erros
                : [errorGettingDefaultMessages],
              type: "warn",
              duration: 1000
            })
          })
      },
      onSearchFiltered(e) {
        this.$emit("onSearchFilter", e)
        this.dataItemsTemp = [...e]
      },
      searchTimeOut() {
        if (this.timer) {
          // previne que a função de busca seja feita varias vezes antes de o usuário terminar de digitar.
          clearTimeout(this.timer) //função javascript
          this.timer = null
        }
        this.timer = setTimeout(() => {
          this.objectSearch(this.defaultMessages, this.inputText)
        }, this.controller.searchTime)
      },
      objectSearch(objectArray, match) {
        if (!match) {
          this.dataItemsTemp = [...this.defaultMessages]
          return
        }
  
        if (!objectArray) {
          return
        }
  
        let objArray = objectArray[0]
  
        if (!Object.keys(objArray)) {
          console.warn("/ Keys Inválidas: ", Object.keys(objArray))
          return
        }
  
        var filtered = objectArray.filter((
          obj //deixar isso variavel
        ) => obj["descricao"].toUpperCase().includes(match.toUpperCase()))
  
        this.onSearchFiltered(filtered)
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  $messagebox-shadow-btn-focus: 0 0 0 0.2rem rgba(77, 158, 195, 0.26);
  
  .message-box {
    &-container {
      position: absolute;
      display: inline-flex;
      margin: 0;
      left: 5px;
    }
  
    &-content {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;

      position: absolute;
      left: 5px;
      top: -20rem;
      width: 50rem;
      height: 20rem;
      background: #f5f5f5;
      box-shadow: $shadow-content-2;
      z-index: $z-index-chat-footer-content;
    }
  
    &-content-wrapper {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }
  
    &-main-button {
      @include default-button();
      padding: 0.5rem 0.5rem;
      font-size: 1.4rem;
      color: $color-btn-text-1;
      background: transparent;
      border: none;
      border-radius: 0.2rem;
  
      &:hover {
        text-shadow: $btn-text-shadow;
        color: #2469ff;
        animation: none;
        transition: color 0.15s ease-in-out, text-shadow 0.15s ease-in-out;
      }
    }
  
    &-header {
      display: flex;
      flex-direction: column;
    }
  
    &-header-title {
      margin: 0 auto 0 auto;
    }
  
    &-search {
      flex-grow: 1;
      display: flex;
      align-items: center;
      margin: 0.8rem 0 0 0.8rem;
  
      input {
        flex-grow: 1;
        padding: 0.3rem 1rem 0.3rem 1rem;
        border: none;
        border-radius: 0.4rem;
        color: $text-color-1;
        transition: box-shadow 0.3s ease-in-out;
        content: "Busque aqui";
        &:hover {
          content: "Busque aqui";
        }
  
        &:focus {
          box-shadow: $messagebox-shadow-btn-focus;
          transition: box-shadow 0.3s ease-in-out;
        }
      }
  
      i {
        margin: 0rem 1rem 0rem 0.5rem;
      }
    }
  }
  
  .content-sub-container {
    height: 10rem;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    overflow-x: hidden;
  
    > div {
      transition: background-color 0.25s ease-in-out;
      &:hover {
        cursor: pointer;
        background: #bccddd;
        transition: background-color 0.25s ease-in-out;
        z-index: $z-index-chat-footer-content;
      }
    }
  }
  
  .content-sub-item {
    display: flex;
    align-self: flex-start;
    flex-direction: row;
    overflow: hidden;
    white-space: pre-wrap;
    text-overflow: ellipsis;
  
    &--stripped {
      background: #e9e9e9;
    }
  
    &--description {
      margin: 0.4rem 0.4rem 0.4rem 0.4rem;
      width: 20rem;
      max-width: 20rem;
      height: 5rem;
      font-weight: 600;
    }
  
    &--text {
      margin: 0.4rem 0.4rem 0.4rem 0.4rem;
      width: 20rem;
      height: 5rem;
    }
  
    &--description-header {
      margin: 1rem 7rem 0.4rem 1rem;
      font-weight: 600;
      font-size: 1rem;
    }
  
    &--text-header {
      font-size: 1rem;
      font-weight: 600;
      margin: 1rem 2rem 0.4rem 1rem;
    }
  }
  .content-sub-item--selected {
  background-color:  rgba(77, 158, 195, 0.26); /* Cor de fundo para realçar o item selecionado */
}
  </style>
  